module.exports = __webpack_public_path__ + "static/img/dialogHeader.b3ebd3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dialogHeader.png
// module id = 1MwO
// module chunks = 1